<section class="faq-section">
  <!-- section heading -->
  <p class="heading">{{ category.name }}</p>
  <!-- category's Q&A -->
  <myclubrewards-faq-category-qa
    *ngFor="let query of category.queries"
    [query]="query"
  ></myclubrewards-faq-category-qa>
</section>
